module.exports = __webpack_public_path__ + "img/page1-5.797cb3bc.png";